import { Box, Text, chakra } from "@chakra-ui/react";
import React from "react";

import EmptySearchResult from "ui/shared/EmptySearchResult";

import DataFetchAlert from "./DataFetchAlert";

type FilterProps = {
  hasActiveFilters: boolean;
  emptyFilteredText: string;
};

type Props = {
  isError: boolean;
  itemsNum?: number;
  emptyText?: React.ReactNode;
  actionBar?: React.ReactNode;
  showActionBarIfEmpty?: boolean;
  showActionBarIfError?: boolean;
  children: React.ReactNode;
  className?: string;
  filterProps?: FilterProps;
};

const DataListDisplay = (props: Props) => {
  if (props.isError) {
    if (props.showActionBarIfError) {
      return (
        <Box className={props.className}>
          {props.actionBar}
          <DataFetchAlert />
        </Box>
      );
    }

    return <DataFetchAlert className={props.className} />;
  }

  if (props.filterProps?.hasActiveFilters && !props.itemsNum) {
    return (
      <Box
        className={props.className}
        bgColor="bg.card"
        borderRadius="base"
        p={{ base: 4, lg: 6 }}
      >
        {props.actionBar}
        <EmptySearchResult text={props.filterProps.emptyFilteredText} />
      </Box>
    );
  }

  if (!props.itemsNum) {
    return (
      <>
        {props.showActionBarIfEmpty && props.actionBar}
        {props.emptyText && (
          <Text className={props.className} p={{ base: 4, lg: 6 }}>
            {props.emptyText}
          </Text>
        )}
      </>
    );
  }

  return (
    <Box
      className={props.className}
      bgColor="bg.card"
      borderRadius="base"
      p={{ base: 4, lg: 6 }}
    >
      {props.actionBar}
      {props.children}
    </Box>
  );
};

export default chakra(DataListDisplay);
